import permissions from '../../permissions'

const USER_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.USERS.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CREATE,
    tag: permissions.USERS.CREATE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.EDIT,
    tag: permissions.USERS.EDIT,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.ACTIVATE_OR_INACTIVATE,
    tag: permissions.USERS.CHANGE_STATUS,
  },
  {
    name: 'Definir uma senha temporária',
    tag: permissions.USERS.TEMP_PASSWORD,
  },
]

export default USER_LIST
